import type { ActionHandler } from '../types';
import { invokeSemanticPort, readString } from './helpers';

export const acceptOfferHandler: ActionHandler = {
  type: 'accept_offer',
  execute(ctx) {
    const config = ctx.config;
    const offerId = readString(config, 'offerId', 'offer_id');
    const port = ctx.semanticPorts?.acceptOffer;
    return invokeSemanticPort(
      ctx,
      'accept_offer',
      port
        ? (context) =>
            port(
              { offerId, stepId: readString(config, 'stepId', 'step_id') ?? ctx.stepId },
              context
            )
        : ctx.onOfferAccept
          ? async () => {
              // The active step offer is a valid host-owned fallback. Managed
              // template defaults therefore do not need to duplicate offerId.
              const outcome = await ctx.onOfferAccept!(offerId ?? '', {
                resultOwner: 'dispatcher',
              });
              if (outcome === false) {
                throw new Error('Host rejected the accept_offer operation');
              }
            }
          : undefined
    );
  },
};
